export default {"src":"/_next/static/media/ic-payment-history.c624d33a.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};